export const SDK_VERSION = '0.8.0';
export const SDK_USER_AGENT = `ostium-builder-sdk/${SDK_VERSION}`;
